// extracted by mini-css-extract-plugin
export default {"App":"App-module_App_IMqMr"};